import React from "react";

export function TwitterOutlined({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4C7.14567 4 4 7.14567 4 11V39C4 42.8543 7.14567 46 11 46H39C42.8543 46 46 42.8543 46 39V11C46 7.14567 42.8543 4 39 4H11ZM11 6H39C41.7737 6 44 8.22633 44 11V39C44 41.7737 41.7737 44 39 44H11C8.22633 44 6 41.7737 6 39V11C6 8.22633 8.22633 6 11 6ZM13.0859 13L22.3086 26.1035L13 37H15.5L23.4375 27.707L29.9766 37H37.9141L27.7891 22.6133L36 13H33.5L26.6602 21.0098L21.0234 13H13.0859ZM16.9141 15H19.9785L34.0859 35H31.0215L16.9141 15Z"
        fill="currentColor"
      />
    </svg>
  );
}
